import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { FatSerie } from '../interfaces/fat-serie';
import { environment } from '../../../environments/environment';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class SerieService {

  readonly path = '/serie';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(cadastro: FatSerie): Observable<FatSerie> {
    return this.http.put<FatSerie>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }

  getFatSerie(id: number ): Observable<FatSerie> {
    return this.http.get<FatSerie>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFatSeriePage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<FatSerie>> {
    return this.http.get<PageResult<FatSerie>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order ?? 'TODOS'}&direction=${direction ?? 'ASC'}`);
  }

  getFatSeriePageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<FatSerie>> {
    return this.http.get<PageResult<FatSerie>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order ?? 'TODOS'}&direction=${direction ?? 'ASC'}`);
  }

}
